import React, { memo } from 'react'
import Typography from '@mui/material/Typography'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'
import ContainerComponent from 'components/shared/ContainerComponent'
import useMediaQuery from '@mui/material/useMediaQuery'
import Divider from '@mui/material/Divider'
import BranchItem from '../BranchItem'
import sx from './styles'

const ToggleSection = ({ item }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  return (
    <>
      <ContainerComponent sx={sx.containerComp}>
        {!isMobile && (
          <Divider sx={sx.divider} />
        )}

        <Typography
          variant="h3"
          sx={sx.branchTitle}
        >
          Sucursales en
          {' '}
          {item.stateName}
          .
        </Typography>

        {item?.branches?.map((branch) => (
          <BranchItem branch={branch} />
        ))}

      </ContainerComponent>
    </>
  )
}

export default memo(ToggleSection)
